import React from "react";
import QuestionsAccordian from "../questionsAccordion/questionsAccordion.component";
import JsonLd from "../jsonLd/jsonLd.component";

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  faqItems?: FAQItem[];
  heading?: string;
  subHeading?: string;
}

export default function FAQSection({
  faqItems = [],
  heading = "Frequently Asked Questions",
  subHeading = "",
}: FAQSectionProps) {
  // FAQPage structured data - makes the Q&A eligible for rich results in search.
  const faqJsonLd =
    faqItems.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqItems.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer?.replace(/<\/?[^>]+(>|$)/g, "") || "",
            },
          })),
        }
      : null;

  return (
    <section className="">
      {faqJsonLd && <JsonLd data={faqJsonLd} />}
      <div className=" scontainer sm:pb-16">
        <QuestionsAccordian
          questions={faqItems}
          heading={heading}
          subHeading={subHeading}
        />
      </div>
    </section>
  );
}
